import { request } from '@/shared/api/request'

export const saveCurrentBin = (bin, flEmployer = false) =>
	request({ url: `/user/save/currentBin/${bin}?flEmployer=${flEmployer}`, method: 'POST' })
